<template>
  <div class="users-index-view">
    <h1>{{$t('titles.index')}}</h1>

    <link-button type="primary" :to="{ name: 'new-user' }" icon="plus">
      {{$t('actions.new')}}
    </link-button>

    <search-input ref="search" v-model="searchQuery" class="uk-align-right" />

    <data-grid :columns="gridColumns"
               :sortable="['name', 'email', 'updatedAt']"
               :rows="users.entries"
               :sort-info="users.sort"
               :page-info="users.pagination"
               :is-loading="isLoading"
               @sort="sortBy"
               v-if="gridLoaded"
               class="uk-margin-medium">
      <span slot="empty">{{$t('hints.empty')}}</span>
      <template slot="row" scope="props">
        <td>
          <router-link :to="{ name: 'edit-user',
                              params: { id: props.row.id } }">
            {{props.row.name}}
          </router-link>
        </td>
        <td>
          {{props.row.email}}
        </td>
        <td>
          <span v-if="props.row.admin">Administrator</span>
          <span v-else>Editor</span>
        </td>
        <td>
          <timeago :since="props.row.updatedAt" :auto-update="60" />
        </td>
        <td>
          <data-grid-actions :edit-route="{ name: 'edit-user',
                                            params: { id: props.row.id } }"
                             @remove="deleteRecordWhenConfirmed(props.row)" />
        </td>
      </template>
    </data-grid>

    <div class="loader-container uk-container uk-margin-medium-top uk-text-center" v-else>
      <loader />
    </div>
  </div>
</template>

<script>
import deleteUserMutation from '@/api/mutations/delete-user.graphql';
import IndexView from '@/mixins/IndexView';
import usersQuery from '@/api/queries/users.graphql';

export default {
  name: 'users-index-view',
  mixins: [
    IndexView('users', {
      gridFields: ['name', 'email', 'role', 'updatedAt'],
      listQuery: usersQuery,
      deleteMutation: deleteUserMutation,
      nameField: 'name',
    }),
  ],
  i18n: {
    messages: {
      de: {
        actions: {
          new: 'Benutzer erstellen',
        },
        confirmations: {
          delete: 'Benutzer <strong>{name}</strong> wirklich löschen?',
        },
        hints: {
          empty: 'Keine Benutzer gefunden',
        },
        toasts: {
          deleted: 'Benutzer gelöscht: {name}',
        },
        titles: {
          index: 'Benutzer',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// IndexView.vue?4103e461